function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.969 20.378a2.394 2.394 0 01-2.394 2.394H2.425a2.394 2.394 0 01-2.394-2.394V3.622a2.394 2.394 0 012.394-2.394h5.984l2.394 3.59h10.772a2.394 2.394 0 012.394 2.395v13.165z"
});

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgFolder;